import { initializeApp } from "firebase/app";
import {
  getFirestore, doc, onSnapshot, setDoc, getDoc,
  initializeFirestore, persistentLocalCache, persistentMultipleTabManager
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDETIguZFEBaoN1piDp9YIiiwx6tFFQX0c",
  authDomain: "accounting-center-f2adb.firebaseapp.com",
  projectId: "accounting-center-f2adb",
  storageBucket: "accounting-center-f2adb.firebasestorage.app",
  messagingSenderId: "66659637098",
  appId: "1:66659637098:web:2acf3a9df8d89e24cdb713"
};

const app = initializeApp(firebaseConfig);
let db;
try {
  db = initializeFirestore(app, {
    localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() })
  });
} catch(e) { db = getFirestore(app); }
export { db };

const DOC_REF = () => doc(db, "center", "main");
const LS_KEY       = "acc_center_cache_v4";
const LS_LOGOS_KEY = "acc_center_logos_v1";

const lsSave  = (d) => { try { localStorage.setItem(LS_KEY, JSON.stringify(d)); } catch {} };
const lsLoad  = () => { try { const v=localStorage.getItem(LS_KEY); return v?JSON.parse(v):null; } catch { return null; } };
const lsClear = () => { try { localStorage.removeItem(LS_KEY); } catch {} };

// الصور محليًا فقط (localStorage) — مش في Firebase
const logosSave = (logos) => { try { localStorage.setItem(LS_LOGOS_KEY, JSON.stringify(logos)); } catch {} };
const logosLoad = () => { try { const v=localStorage.getItem(LS_LOGOS_KEY); return v?JSON.parse(v):{}; } catch { return {}; } };

// استخرج الصور من الـ DB وحفظها محليًا
function stripLogos(data) {
  if (!data) return data;
  const logos = {};
  const clean = { ...data };

  // لوجو المركز
  if (clean.centerLogo) { logos.centerLogo = clean.centerLogo; delete clean.centerLogo; }

  // لوجوهات الدورات
  if (clean.courses) {
    clean.courses = clean.courses.map(c => {
      if (c.logo) { logos[`course_${c.id}`] = c.logo; return { ...c, logo: "" }; }
      return c;
    });
  }

  return { clean, logos };
}

// أعد الصور للـ DB بعد التحميل
function restoreLogos(data, logos) {
  if (!data || !logos) return data;
  const result = { ...data };
  if (logos.centerLogo) result.centerLogo = logos.centerLogo;
  if (result.courses) {
    result.courses = result.courses.map(c => ({
      ...c,
      logo: logos[`course_${c.id}`] || c.logo || ""
    }));
  }
  return result;
}

let _saving = false;
let _saveTimer = null;

export async function loadFromFirebase(defaultDB) {
  const base = typeof defaultDB === "function" ? defaultDB() : (defaultDB || {});
  const localLogos = logosLoad();

  try {
    const snap = await getDoc(DOC_REF());
    if (snap.exists()) {
      const raw = snap.data();
      const data = restoreLogos({ ...base, ...raw }, localLogos);
      lsSave(data);
      return data;
    } else {
      lsClear();
      return restoreLogos(base, localLogos);
    }
  } catch(e) {
    const cached = lsLoad();
    return cached ? restoreLogos({ ...base, ...cached }, localLogos) : restoreLogos(base, localLogos);
  }
}

export function saveToFirebase(data) {
  // حفظ الصور محليًا دايمًا
  const { clean, logos } = stripLogos(data);
  logosSave({ ...logosLoad(), ...logos });

  // حفظ الـ DB كامل (مع الصور) في localStorage للعرض الفوري
  lsSave(data);

  // بعت Firebase نسخة بدون صور
  clearTimeout(_saveTimer);
  _saveTimer = setTimeout(async () => {
    _saving = true;
    try {
      await setDoc(DOC_REF(), clean);
    } catch(e) {
      console.warn("Firebase save failed:", e.message);
    } finally {
      setTimeout(() => { _saving = false; }, 1000);
    }
  }, 800);
}

export function subscribeToFirebase(callback) {
  return onSnapshot(
    DOC_REF(),
    (snap) => {
      if (_saving) return;
      if (snap.exists()) {
        const raw = snap.data();
        const localLogos = logosLoad();
        const data = restoreLogos(raw, localLogos);
        lsSave(data);
        callback(data);
      } else {
        lsClear();
      }
    },
    (e) => { console.warn("Firebase listener:", e.message); }
  );
}
